

























































































































































import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import DashboardView from '@ui/Dashboard/Layout/DashboardView'
import CampaignDashboardHeader from '@ui/Dashboard/Views/Campaign/CampaignDashboardHeader'
import PurchaseOffersBarChart from '@ui/Dashboard/Charts/Purchase/PurchaseOffersBarChart'
import PurchaseSamplesDoughnutChart from '@ui/Dashboard/Charts/Purchase/PurchaseSamplesDoughnutChart'
import PurchaseVenuesBarChart from '@ui/Dashboard/Charts/Purchase/PurchaseVenuesBarChart'
import PurchaseReachBarChart from '@ui/Dashboard/Charts/Purchase/PurchaseReachBarChart'
import PurchaseSeriesLineChart from '@ui/Dashboard/Charts/Purchase/PurchaseSeriesLineChart'
import ListingsTopPrimaryTypesBarChart from '@ui/Dashboard/Charts/Listings/ListingsTopPrimaryTypesBarChart'
import ListingsTopVenuesListChart from '@ui/Dashboard/Charts/Listings/ListingsTopVenuesListChart'
import RecapsPhotosGallery from '@ui/Dashboard/Charts/Recaps/RecapsPhotosGallery'
import RecapsPostsSummaryChart from '@ui/Dashboard/Charts/Recaps/RecapsPostsSummaryChart'
import RecapsPostsGaugeChart from '@ui/Dashboard/Charts/Recaps/RecapsPostsGaugeChart'
import DemographicsGenderDoughnutChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsGenderDoughnutChart'
import DemographicsRaceBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsRaceBarChart'
import DemographicsAgeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsAgeBarChart'
import DemographicsEducationBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsEducationBarChart'
import DemographicsIncomeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsIncomeBarChart'
import PersonasProfilesBarChart from '@ui/Dashboard/Charts/Audience/Personas/PersonasProfilesBarChart'

settings =
  name: 'CampaignDashboardView'

  resources:
    dashboard:
      resourceName: 'dashboard'
      slug: 'brand_reps/:brandRep.id/dashboard/campaign'
      fetch: false

  vue:
    props: ['brandRep', 'options']

    components: {
      DashboardView,
      CampaignDashboardHeader,
      PurchaseOffersBarChart,
      PurchaseSamplesDoughnutChart,
      PurchaseVenuesBarChart,
      PurchaseReachBarChart,
      PurchaseSeriesLineChart,
      ListingsTopPrimaryTypesBarChart,
      ListingsTopVenuesListChart,
      RecapsPhotosGallery,
      RecapsPostsSummaryChart,
      RecapsPostsGaugeChart,
      DemographicsGenderDoughnutChart,
      DemographicsRaceBarChart,
      DemographicsAgeBarChart,
      DemographicsEducationBarChart,
      DemographicsIncomeBarChart,
      PersonasProfilesBarChart,
    }

    computed:
      campaign: ->
        @options?.campaign

      suppliers: ->
        @prime?.options?.suppliers || []

    methods:
      hiDownload: ->
        console.log 'TODO: download dashboard data'

      hiApplyFilter: ({ target }) ->
        @fetch 'dashboard', { target }

      resolveNumber: (dotPath) ->
        ChartUtility.resolveNumber @dashboard, dotPath

export default VueOptions.vue settings
